export const materialTheme = function (p = {}) {

    const {mediaQuery = {}} = p;
    const prefersDarkMode = mediaQuery["(prefers-color-scheme: dark)"];
    const printMode = mediaQuery["print"];

    const dark = !!(prefersDarkMode && !printMode);

    return {
        palette: {
            primary: {
                main: (dark) ? "#ffffff" : "#000000",
            },
            secondary: {
                main: (dark) ? "#426dfb" : "#426dfb",
            },
            background: {
                paper: (dark) ? "#303338" : "#ffffff",
            },
            error: {
                main: "rgba(244, 67, 54, 1)"
            },
            mode: dark ? "dark" : "light",
        },
    }
};

export const materialMediaQuery = ["(prefers-color-scheme: dark)", "print"];
